/**
 * Breadcrumb Vuex module
 *
 * Manages a navigation breadcrumb trail so users always know
 * where they are in the drill-down hierarchy.
 *
 * Crumb shape: { label: String, icon: String, route: Object|null }
 */
export default {
    state: {
        trail: [],
    },

    mutations: {
        SET_BREADCRUMB_TRAIL(state, trail) {
            state.trail = [...trail];
        },

        PUSH_BREADCRUMB(state, crumb) {
            state.trail = [...state.trail, crumb];
        },

        CLEAR_BREADCRUMBS(state) {
            state.trail = [];
        },
    },

    getters: {
        breadcrumbTrail: (state) => state.trail,
    },
};
